import React, { useRef, useState } from 'react';
import { exportToJson, importFromJson } from '../services/exportImportService';
import { Download, Upload, Check, AlertCircle } from 'lucide-react';

interface ImportExportButtonsProps {
  data: any;
  onImport: (data: any) => void;
  fileName: string;
  buttonTitle: string;
}

const ImportExportButtons: React.FC<ImportExportButtonsProps> = ({
  data,
  onImport,
  fileName,
  buttonTitle
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [importStatus, setImportStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [importError, setImportError] = useState<string | null>(null);

  const handleExport = () => {
    exportToJson(data, fileName);
  };

  const handleImportClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (file) {
      importFromJson(
        file,
        (importedData) => {
          onImport(importedData);
          setImportStatus('success');
          setTimeout(() => setImportStatus('idle'), 3000);
        },
        (error) => {
          setImportError(error);
          setImportStatus('error');
          setTimeout(() => {
            setImportStatus('idle');
            setImportError(null);
          }, 5000);
        }
      );
    }

    // Limpa o input para permitir que o mesmo arquivo seja selecionado novamente
    if (e.target) {
      e.target.value = '';
    }
  };

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={handleExport}
        className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors flex items-center gap-2"
        title={`Exportar ${buttonTitle}`}
      >
        <Download size={18} />
        <span className="hidden sm:inline">Exportar {buttonTitle}</span>
        <span className="inline sm:hidden">Exportar</span>
      </button>

      <button
        onClick={handleImportClick}
        className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 transition-colors flex items-center gap-2"
        title={`Importar ${buttonTitle}`}
      >
        <Upload size={18} />
        <span className="hidden sm:inline">Importar {buttonTitle}</span>
        <span className="inline sm:hidden">Importar</span>
      </button>

      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept=".json"
        className="hidden"
      />

      {importStatus === 'success' && (
        <div className="bg-green-100 text-green-700 px-3 py-1 rounded-lg flex items-center gap-1">
          <Check size={16} />
          <span>Importado com sucesso</span>
        </div>
      )}

      {importStatus === 'error' && (
        <div className="bg-red-100 text-red-700 px-3 py-1 rounded-lg flex items-center gap-1">
          <AlertCircle size={16} />
          <span>{importError || 'Erro ao importar'}</span>
        </div>
      )}
    </div>
  );
};

export default ImportExportButtons; 